import { render, staticRenderFns } from "./SlotMachine.vue?vue&type=template&id=52f1a984"
import script from "./SlotMachine.vue?vue&type=script&lang=js"
export * from "./SlotMachine.vue?vue&type=script&lang=js"
import style0 from "./SlotMachine.vue?vue&type=style&index=0&id=52f1a984&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
